'use client'
import { UseQueryResult, useQuery } from '@tanstack/react-query'
import services from '../services'
import { apiResponseHandler, queryKeys } from '@/shared/api/react-query'
import { GetProjectParams } from '@/shared/api/end-points/project'
import { Project, projectMappers } from '../../lib'
import { useGetProjectId } from '@/app/slugs'

const useHook = (partialParams?: GetProjectParams) => {
  const projectIdParams = useGetProjectId()
  const params = partialParams || projectIdParams

  const queryKey = [queryKeys((a, m, p) => a.project.getProject(params) + m.get)]

  const query = useQuery({
    queryKey,
    queryFn: async () => apiResponseHandler(await services.getOne(params)),
    refetchOnWindowFocus: false,
    refetchInterval: (query) => {
      const tasks = (query.state.data?.growth_point?.tasks || []).filter((item) => item != null)
      if (tasks.length > 0) return false
      return 30 * 1000
    },
  })

  const queryResult = {
    ...query,
    queryKey,
    data: projectMappers.mapProject(query?.data || {}),
  }

  return queryResult as unknown as UseQueryResult<Project>
}
export default useHook
